export interface Scientist {
  id: string;
  name: string;
  nameEn: string;
  years: string;
  nationality: string;
  icon: string;
  tagline: string;
  contribution: string;
  funFact: string;
  searchKeyword: string;
}

export const scientists: Scientist[] = [
  // ── 古代中国 ──
  {
    id: 'gande-shen',
    name: '甘德与石申',
    nameEn: 'Gan De & Shi Shen',
    years: '约公元前4世纪',
    nationality: '中国·战国',
    icon: '⭐',
    tagline: '世界上最早的星表作者',
    contribution:
      '甘德和石申是战国时期两位天文学家，分别著有《天文星占》和《天文》。他们编制的星表比希腊的喜帕恰斯星表早了两个世纪，记录了约800颗恒星的位置。甘德还最早用肉眼发现了木星的卫星（比伽利略的望远镜观测早了近两千年），并在公元前240年左右记录了哈雷彗星的回归。',
    funFact: '1970年代，国际天文学联合会用甘德和石申的名字命名了月球背面的两座环形山，以纪念他们的贡献。',
    searchKeyword: '甘德 石申 星表 哈雷彗星',
  },
  {
    id: 'zhang-heng',
    name: '张衡',
    nameEn: 'Zhang Heng',
    years: '78—139年',
    nationality: '中国·东汉',
    icon: '🔮',
    tagline: '世界上第一台地震仪的发明者',
    contribution:
      '张衡是中国古代最伟大的天文学家之一。他发明了"候风地动仪"——世界上第一台检测地震方向的仪器。他还制造了"浑天仪"，用精密的齿轮系统模拟天体运动，比欧洲的类似装置早了一千多年。他在《灵宪》中提出了宇宙无限论，认为"宇之表无极，宙之端无穷"。',
    funFact: '张衡不仅懂天文，还是文学家、画家和数学家。他的《二京赋》是汉赋的代表作，被誉为"长篇之极轨"。',
    searchKeyword: '张衡 地动仪 浑天仪',
  },
  {
    id: 'shen-kuo',
    name: '沈括',
    nameEn: 'Shen Kuo',
    years: '1031—1095年',
    nationality: '中国·北宋',
    icon: '🧭',
    tagline: '中国科学史上的坐标',
    contribution:
      '沈括在《梦溪笔谈》中记录了丰富的天文观测成果。他改进了浑仪的结构，简化了漏刻的设计，并首次提出"冬至日行速、夏至日行缓"的行星运动不均匀性现象。他还在观测基础上推算了北极星的实际位置，并解释了月相的成因。他提出的"十二气历"以节气定月，比欧洲类似的格里高利历早了近600年。',
    funFact: '沈括晚年隐居润州梦溪园，用笔记体写成了《梦溪笔谈》，涉及天文、数学、地质、物理、生物、医药等十几个领域，被李约瑟誉为"中国科学史上的里程碑"。',
    searchKeyword: '沈括 梦溪笔谈 十二气历',
  },
  {
    id: 'guo-shoujing',
    name: '郭守敬',
    nameEn: 'Guo Shoujing',
    years: '1231—1316年',
    nationality: '中国·元朝',
    icon: '🏗️',
    tagline: '中国古代最伟大的天文仪器制造家',
    contribution:
      '郭守敬在元大都（今北京）建造了当时世界上最大的天文台——司天台。他设计制造了简仪、仰仪、高表等20多种天文仪器，其中"简仪"的结构比欧洲类似的赤道仪早了300年。他主持的"四海测验"在全国设立了27个观测站，是当时规模最大的天文测量工程。他编制的《授时历》以365.2425天为一年，与格里高利历一致，但早了300多年。',
    funFact: '1977年，中国将发现的一颗小行星命名为"郭守敬星"。郭守敬的画像被印在了中国邮政的纪念邮票上。月球背面也有一座以他命名的环形山。',
    searchKeyword: '郭守敬 授时历 简仪',
  },
  {
    id: 'su-song',
    name: '苏颂',
    nameEn: 'Su Song',
    years: '1020—1101年',
    nationality: '中国·北宋',
    icon: '🕰️',
    tagline: '水运仪象台的建造者',
    contribution:
      '苏颂主持建造了水运仪象台，集浑仪（观测）、浑象（演示）和自动报时装置于一体，由水力驱动。这是世界上最早的天文钟，也是人类第一次用精密的机械装置模拟天体运行。水运仪象台高约11米，分三层，每到一个时辰（相当于现代的2小时），就会有木偶人出来敲钟击鼓报时。',
    funFact: '苏颂的水运仪象台使用了类似擒纵器的装置，这比欧洲最早的钟表擒纵器早了约200年。他的著作《新仪象法要》详细记录了仪器的设计图，是世界上现存最早的机械设计图纸。',
    searchKeyword: '苏颂 水运仪象台 新仪象法要',
  },

  // ── 古希腊 ──
  {
    id: 'aristarchus',
    name: '阿里斯塔克',
    nameEn: 'Aristarchus of Samos',
    years: '约公元前310—230年',
    nationality: '古希腊',
    icon: '☀️',
    tagline: '古代日心说的先驱',
    contribution:
      '阿里斯塔克是历史上最早提出日心说的人。他大胆地提出太阳位于宇宙中心，地球和其他行星绕太阳公转——比哥白尼早了约1800年。他还率先尝试用几何方法测量日地距离和月地距离：利用上弦月时日地月构成的直角三角形关系。虽然受限于观测精度，他的计算结果偏小，但方法本身是正确的。',
    funFact: '阿里斯塔克的日心说没被当时的人接受，因为人们感觉不到地球在运动。加上亚里士多德的权威影响，他的思想被埋没了近两千年。今天的我们知道，感觉不到运动恰恰是因为所有东西都在跟着地球一起运动。',
    searchKeyword: '阿里斯塔克 日心说 古希腊天文学',
  },
  {
    id: 'ptolemy',
    name: '克劳狄乌斯·托勒密',
    nameEn: 'Claudius Ptolemy',
    years: '约100—170年',
    nationality: '希腊·罗马',
    icon: '📜',
    tagline: '地心说体系的集大成者',
    contribution:
      '托勒密在其巨著《天文学大成》（Almagest）中系统总结了古希腊天文学的成就，建立了以地球为中心、行星在"本轮"和"均轮"上运行的地心说模型。这个模型虽然复杂（需要80多个本轮来解释行星的逆行），但能较精确地预测行星位置。《天文学大成》包含了世界上最早的恒星目录之一，也是此后1400多年西方天文学的权威教材。',
    funFact: '托勒密不仅是天文学家，还是地理学家、数学家和占星学家。他的《地理学指南》包含了一幅世界地图和8000多个地点的坐标，是地理学史上最重要的著作之一。',
    searchKeyword: '托勒密 天文学大成 地心说',
  },

  // ── 中世纪 ──
  {
    id: 'al-khwarizmi',
    name: '阿尔·花拉子米',
    nameEn: 'Al-Khwarizmi',
    years: '约780—850年',
    nationality: '阿拉伯·波斯',
    icon: '📐',
    tagline: '代数学之父，天文表的编纂者',
    contribution:
      '阿尔·花拉子米被誉为"代数学之父"。他的著作《还原与对消》（Al-Jabr）奠定了代数学的基础——"算法"（algorithm）一词就来源于他的名字。他还编纂了《信德天文表》，将印度数字系统和零的概念传入阿拉伯世界，并最终传到欧洲。他的天文表精确计算了太阳、月亮和五大行星的位置，为后来的伊斯兰和欧洲天文学奠定了基础。',
    funFact: '我们使用的"阿拉伯数字"（0,1,2,3...）其实是印度人发明的，是花拉子米将它们系统化并通过拉丁文译本传入了欧洲。',
    searchKeyword: '花拉子米 代数学 算法 信德天文表',
  },
  {
    id: 'al-sufi',
    name: '阿卜杜勒-拉赫曼·苏菲',
    nameEn: 'Abd al-Rahman al-Sufi',
    years: '903—986年',
    nationality: '波斯',
    icon: '🌌',
    tagline: '恒星亮度的系统记录者',
    contribution:
      '苏菲是波斯最伟大的天文学家之一，著有《恒星之书》（Kitab al-Kawākib al-Thābitah）。在这部经典中，他修正和补充了托勒密的星表，首次系统记录了恒星的颜色和亮度，并准确描述了仙女座星系——人类有记载以来第一个被确认的"河外星系"（当时他描述为"一朵小云"）。他也是最早记录麦哲伦星云的天文学家之一。',
    funFact: '苏菲在《恒星之书》中描绘了每个星座的两张图——一张从天球外看，一张从天球里看——这种"内外对照"的方式对后世的星图绘制产生了深远影响。',
    searchKeyword: '苏菲 恒星之书 仙女座星系',
  },

  // ── 科学革命 ──
  {
    id: 'copernicus',
    name: '尼古拉·哥白尼',
    nameEn: 'Nicolaus Copernicus',
    years: '1473—1543年',
    nationality: '波兰',
    icon: '🔄',
    tagline: '日心说的创立者',
    contribution:
      '哥白尼在其临终前出版的《天体运行论》中系统地提出了日心说：太阳位于宇宙中心，地球和其他行星绕太阳公转。这一颠覆性的理论挑战了统治欧洲1500多年的托勒密地心说。哥白尼模型不仅解释了行星的逆行运动（这在地心说中需要复杂的本轮系统），还为后来开普勒发现行星运动定律和牛顿建立万有引力理论开辟了道路。',
    funFact: '传说《天体运行论》的第一本样书送到哥白尼手中时，他正躺在病床上。据说他摸了摸书的封面，几分钟后就安详去世了——他不必面对这本书引发的巨大争议。罗马教廷直到1616年才将这本书列为禁书，晚了70多年。',
    searchKeyword: '哥白尼 日心说 天体运行论',
  },
  {
    id: 'tycho-brahe',
    name: '第谷·布拉赫',
    nameEn: 'Tycho Brahe',
    years: '1546—1601年',
    nationality: '丹麦',
    icon: '👁️',
    tagline: '肉眼观测时代的巅峰',
    contribution:
      '第谷·布拉赫是望远镜发明前最伟大的观测天文学家。他在汶岛建造了天文台，用自制的巨型象限仪和六分仪进行了长达20多年的精确观测，记录下777颗恒星的位置，误差仅有几角分。他观测了1572年出现在仙后座的超新星，证明"天界也是变化的"——这对亚里士多德"天界不变"的教条是致命一击。',
    funFact: '第谷年轻时在决斗中被人削掉了鼻子，此后他戴着一个由金、银和铜混合制成的假鼻子度过余生。他还在汶岛上养了一头驯鹿，据说他的驯鹿因喝醉酒从楼梯上掉下来摔死了。第谷的死因也很离奇——据说是因憋尿过度导致膀胱破裂。',
    searchKeyword: '第谷布拉赫 超新星 汶岛天文台',
  },
  {
    id: 'kepler',
    name: '约翰内斯·开普勒',
    nameEn: 'Johannes Kepler',
    years: '1571—1630年',
    nationality: '德国',
    icon: '📐',
    tagline: '行星运动三定律的发现者',
    contribution:
      '开普勒基于第谷·布拉赫的精确观测数据，先后提出了行星运动三定律：（一）行星沿椭圆轨道运行，太阳位于一个焦点；（二）相等时间扫过相等面积；（三）轨道周期的平方与半长轴的立方成正比。开普勒定律第一次用精确的数学方程描述了行星运动，打破了"天体必须是完美圆形轨道"的古老教条，是牛顿万有引力定律的基础。',
    funFact: '开普勒最初坚信完美圆形轨道，经过70多次计算失败后才最终接受椭圆轨道。他感叹道："我打破了一切障碍，推开了所有灰尘，终于看到了最光辉的真理。"他的母亲曾被指控为女巫，开普勒花了六年时间为她辩护，最终使她获释。',
    searchKeyword: '开普勒三定律 椭圆轨道 天体力学',
  },
  {
    id: 'galileo',
    name: '伽利略·伽利莱',
    nameEn: 'Galileo Galilei',
    years: '1564—1642年',
    nationality: '意大利',
    icon: '🔭',
    tagline: '现代科学之父',
    contribution:
      '伽利略自己磨制了约20倍放大率的望远镜，首次将其对准夜空。他发现了月球表面的环形山和山脉、木星的四颗大卫星（以他名字命名的"伽利略卫星"）、金星的盈亏相位变化，以及银河由无数恒星组成。这些发现为日心说提供了强有力的观测证据。他还研究了自由落体和抛物线运动，奠定了现代物理学的基础。',
    funFact: '伽利略因支持日心说被罗马教廷审判，被迫公开宣布放弃自己的观点。传说他低声说了一句"但它仍在转动"（E pur si muove）。虽然这个故事可能不是真的，但它已成为科学不屈从于权威的象征。1992年，教皇约翰·保罗二世正式为教廷对伽利略的错误审判道歉。',
    searchKeyword: '伽利略 望远镜 木星卫星 日心说',
  },
  {
    id: 'newton',
    name: '艾萨克·牛顿',
    nameEn: 'Isaac Newton',
    years: '1643—1727年',
    nationality: '英国',
    icon: '🍎',
    tagline: '万有引力和经典物理的奠基人',
    contribution:
      '牛顿的万有引力定律统一了天上和地下的物理学：地球上让苹果下落的力和让月球绕地球转的力是同一种力。他建立了经典力学的完整体系（牛顿三定律），发明了微积分，在光学领域也做出了开创性贡献（发现白光可分解为七色光谱，发明反射望远镜）。他的《自然哲学的数学原理》是科学史上最重要的著作之一。',
    funFact: '牛顿在剑桥大学读书期间因躲避瘟疫回到家乡，在那18个月里他奠定了微积分、万有引力和光学的三大基础。后世称这18个月为"奇迹之年"。他还担任过皇家造币厂总监，在打击伪币方面做出了重要贡献。',
    searchKeyword: '牛顿 万有引力 自然哲学的数学原理',
  },
  {
    id: 'herschel',
    name: '威廉·赫歇尔',
    nameEn: 'William Herschel',
    years: '1738—1822年',
    nationality: '英国（生于德国）',
    icon: '🪐',
    tagline: '天王星的发现者，银河系结构的探索者',
    contribution:
      '威廉·赫歇尔在用自制望远镜巡天观测时发现了天王星——这是人类历史上第一次"发现"一颗新行星（水、金、火、木、土自古已知）。他还发现了土星的两颗卫星和天王星的两颗卫星，并第一个发现了太阳发出的红外线。他通过系统统计恒星的数量和分布，首次描绘了银河系的大致形状——一个扁平的圆盘状结构。',
    funFact: '赫歇尔最初是音乐家——他在成为天文学家之前是职业双簧管演奏家和管风琴手。他的妹妹卡罗琳·赫歇尔也是杰出的天文学家，是英国历史上第一位领取薪俸的女性天文学家，发现了多颗彗星和星云。兄妹二人一生合作，传为佳话。',
    searchKeyword: '威廉赫歇尔 天王星 银河系结构',
  },

  // ── 现代天文学 ──
  {
    id: 'henrietta-leavitt',
    name: '亨丽爱塔·勒维特',
    nameEn: 'Henrietta Leavitt',
    years: '1868—1921年',
    nationality: '美国',
    icon: '💫',
    tagline: '发现宇宙距离尺度的女性天文学家',
    contribution:
      '亨丽爱塔·勒维特在哈佛大学天文台担任"计算员"（当时女性不被允许使用望远镜）时，发现了造父变星的"周光关系"：变星的光变周期越长，其固有亮度就越大。这一发现让天文学家第一次能够精确测量遥远星系的距离。哈勃正是利用勒维特的发现，证明了银河系之外还存在其他星系，并测量了宇宙的膨胀。',
    funFact: '勒维特的周光关系被天文学家沙普利称为"发现宇宙的关键"。如果没有她的工作，人类可能还要晚几十年才知道宇宙在膨胀。勒维特一生饱受听力障碍困扰，但从未因此放弃科学研究。',
    searchKeyword: '亨丽爱塔勒维特 造父变星 周光关系',
  },
  {
    id: 'cecilia-payne',
    name: '塞西莉亚·佩恩-加波施金',
    nameEn: 'Cecilia Payne-Gaposchkin',
    years: '1900—1979年',
    nationality: '英国·美国',
    icon: '⚛️',
    tagline: '发现恒星由氢和氦组成',
    contribution:
      '塞西莉亚·佩恩在1925年的博士论文中做出了革命性的论断：恒星主要由氢和氦组成。这个结论在当时被认为是荒谬的——主流观点认为太阳和地球的组成元素差不多。然而后来的观测完全证实了她的发现。今天我们知道，氢和氦占了宇宙可见物质的98%以上。她的论文被天文学家奥托·斯特鲁维称为"天文学史上最杰出的博士论文"。',
    funFact: '佩恩的博士论文导师沙普利（哈佛天文台台长）劝她不要发表"恒星主要由氢组成"的结论，因为"这太违背常识"。佩恩在论文中谨慎地写道这个结果"可能不是真实的"。几年后光谱分析完全证实了她的发现，沙普利承认了自己的保守。',
    searchKeyword: '塞西莉亚佩恩 恒星组成 氢氦',
  },
  {
    id: 'edwin-hubble',
    name: '埃德温·哈勃',
    nameEn: 'Edwin Hubble',
    years: '1889—1953年',
    nationality: '美国',
    icon: '🌌',
    tagline: '发现宇宙膨胀的天文学家',
    contribution:
      '埃德温·哈勃用威尔逊山天文台2.5米望远镜做出了两项划时代的发现：第一，他证实了仙女座大星云远在银河系之外，证明宇宙中有无数个"岛宇宙"（星系）；第二，他发现星系的光谱线普遍向红端移动（红移），且距离越远的星系退行速度越快——这就是哈勃定律，直接证明了宇宙正在膨胀。爱因斯坦得知后，称修正自己宇宙常数项为"一生中最大的错误"。',
    funFact: '哈勃年轻时是出色的运动员，曾在拳击比赛中打断过对手的鼻子。他还曾在牛津大学攻读法律，回国后才转向天文学。哈勃的旧金山豪宅后来被用于拍摄电影《公民凯恩》的外景。为纪念他的贡献，哈勃太空望远镜以他的名字命名。',
    searchKeyword: '哈勃 宇宙膨胀 哈勃定律',
  },
  {
    id: 'jocelyn-bell',
    name: '约瑟琳·贝尔',
    nameEn: 'Jocelyn Bell Burnell',
    years: '1943年—',
    nationality: '英国·北爱尔兰',
    icon: '📡',
    tagline: '脉冲星的发现者',
    contribution:
      '1967年，年仅24岁的约瑟琳·贝尔（当时还是剑桥大学研究生）在检查射电望远镜数据时，发现了一种规律的"闪烁"信号。她最初戏称它为"LGM"（Little Green Men，小绿人），以为是外星文明发出的信号。但后来她和导师休伊什确认，这是一种快速旋转的中子星——脉冲星。然而1974年诺贝尔物理学奖颁给了导师休伊什，而非贝尔本人，引发了长达数十年的科学伦理争议。',
    funFact: '贝尔虽然没有获得诺贝尔奖，但她在2018年获得了基础物理学特别突破奖（奖金300万美元）。她将全部奖金捐给了支持女性和少数族裔进入物理学的基金会。她说："我本不该得到诺贝尔奖，但我要用这个奖来帮助那些本该得到机会的人。"',
    searchKeyword: '约瑟琳贝尔 脉冲星 中子星 诺贝尔奖争议',
  },
  {
    id: 'vera-rubin',
    name: '薇拉·鲁宾',
    nameEn: 'Vera Rubin',
    years: '1928—2016年',
    nationality: '美国',
    icon: '🌌',
    tagline: '暗物质存在的观测证实者',
    contribution:
      '薇拉·鲁宾通过观测螺旋星系的旋转曲线，发现星系边缘的恒星运动速度远比理论预测的快——这意味着存在大量我们看不见的物质在提供额外引力。她的发现为"暗物质"的存在提供了最直接、最坚实的观测证据。在鲁宾之前，暗物质只是一个理论猜想；她的数据将暗物质从假设变成了现代宇宙学的基本组成部分。',
    funFact: '鲁宾从小就热爱天文，每晚在卧室窗口观测流星。她的中学物理老师告诉她："你不应该学物理，女孩不适合。"她没有放弃，最终改变了人类对宇宙的理解。她一生坚持拒绝出席只有男性才能参加的学术活动，为科学界的性别平等做出了重要贡献。',
    searchKeyword: '薇拉鲁宾 暗物质 星系旋转曲线',
  },
  {
    id: 'carl-sagan',
    name: '卡尔·萨根',
    nameEn: 'Carl Sagan',
    years: '1934—1996年',
    nationality: '美国',
    icon: '🌍',
    tagline: '宇宙科普的传奇人物',
    contribution:
      '卡尔·萨根是20世纪最杰出的科学传播者。他的电视系列片《宇宙》（Cosmos）在1980年首播，被全球60多个国家的5亿人收看，至今仍是科普史上的丰碑。在天文学研究方面，他参与了美国的金星探测项目（发现金星表面温度极高）、火星探测器和旅行者号计划。他还设计了旅行者号的"金唱片"——一张搭载人类文明信息的唱片，希望未来有外星文明能够发现它。',
    funFact: '萨根的科幻小说《接触》（Contact）被改编成同名电影（朱迪·福斯特主演）。书中描述的虫洞星际旅行和"宇宙中智慧生命的数量"的讨论引起了巨大反响。萨根还以他那句名言著称："我们是宇宙认识自己的一种方式。"（We are a way for the cosmos to know itself.）',
    searchKeyword: '卡尔萨根 宇宙 金唱片 科学传播',
  },
  {
    id: 'stephen-hawking',
    name: '斯蒂芬·霍金',
    nameEn: 'Stephen Hawking',
    years: '1942—2018年',
    nationality: '英国',
    icon: '♿',
    tagline: '黑洞辐射的发现者',
    contribution:
      '霍金提出了"霍金辐射"理论——证明黑洞并非完全"黑"的，而是会发出微弱的辐射并逐渐蒸发。这一理论首次将广义相对论、量子力学和热力学联系在了一起，是理论物理学的重要里程碑。他的《时间简史》自1988年出版以来销量超过2500万册，是史上最成功的科普著作之一。他还提出了宇宙无边界假设，推动了量子宇宙学的发展。',
    funFact: '霍金21岁时被诊断出患有肌萎缩侧索硬化症（ALS），医生预计他只能活两年。但他顽强地与疾病抗争了55年，几乎全身瘫痪，只能通过眼球追踪和语音合成器交流。他说："我的目标很简单——完全理解宇宙，理解它为何如此，以及它为何存在。"霍金曾在电视剧《生活大爆炸》和《辛普森一家》中"出演"自己。',
    searchKeyword: '霍金 霍金辐射 时间简史 黑洞',
  },
];

export function getScientistById(id: string): Scientist | undefined {
  return scientists.find((s) => s.id === id);
}
